import { PMJobRunSupportLevel } from 'src/app/modules/platform/monitoring/models/pm-job-run-support-level';

export interface SupportLevelOptionVM {
    supportLevel: PMJobRunSupportLevel;
    name: string;
    ico: string;
}

export const ALL_SUPPORT_LEVEL_OPTION_VM = {
    supportLevel: PMJobRunSupportLevel.all,
    name: 'All deployment statuses',
    ico: ''
};
export const DEVELOPMENT_SUPPORT_LEVEL_OPTION_VM = {
    supportLevel: PMJobRunSupportLevel.development,
    name: 'Development',
    ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-development'
};

export const SUPPORT_LEVEL_OPTION_VMS: SupportLevelOptionVM[] = [
    ALL_SUPPORT_LEVEL_OPTION_VM,
    {
        supportLevel: PMJobRunSupportLevel.production,
        name: 'Production',
        ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-production'
    },
    DEVELOPMENT_SUPPORT_LEVEL_OPTION_VM,
    {
        supportLevel: PMJobRunSupportLevel.qaReview,
        name: 'QA Review',
        ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-qa-review'
    },
    {
        supportLevel: PMJobRunSupportLevel.inactive,
        name: 'Inactive',
        ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-inactive'
    },
    {
        supportLevel: PMJobRunSupportLevel.static,
        name: 'Static',
        ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-static'
    },
    {
        supportLevel: PMJobRunSupportLevel.unknown,
        name: 'Unknown',
        ico: 'cdp-dev-status-indicator cdp-dev-status-indicator-unknown'
    }
];
